// extracted by mini-css-extract-plugin
export default {"app":"App_app__KxNr0","mainContent":"App_mainContent__aft48","sectionWrapper":"App_sectionWrapper__5koN7","fadeIn":"App_fadeIn__5vWJp"};